import { render, staticRenderFns } from "./ModalFormulario.vue?vue&type=template&id=01c5b21b&scoped=true"
import script from "./ModalFormulario.vue?vue&type=script&lang=js"
export * from "./ModalFormulario.vue?vue&type=script&lang=js"
import style0 from "./ModalFormulario.vue?vue&type=style&index=0&id=01c5b21b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c5b21b",
  null
  
)

export default component.exports